import { Component } from '@angular/core';
import { FeatureManagementService } from 'src/shared/services/feature-management.service';

@Component({
  selector: 'cert-epp-nav-menu',
  templateUrl: './epp-nav-menu.component.html',
  styles: ``,
  standalone: false,
})
export class EppNavMenuComponent {
  vouchersEnabled$ = this.featureManager.isFeatureEnabled('vouchers');

  constructor(private readonly featureManager: FeatureManagementService) {}
}
